module.exports = __webpack_public_path__ + "img/nn-logo.svg";